<template>
  <div id="app">
    <LoginPage v-if="!isLoggedIn" @login-success="onLoginSuccess" />
    <AppLayout v-else @logout="onLogout" />
  </div>
</template>

<script>
import AppLayout from "./components/AppLayout.vue";
import LoginPage from "./components/LoginPage.vue";
import { isLoggedIn as checkLoggedIn, removeToken } from "./api/token";

export default {
  name: "App",
  components: {
    LoginPage,
    AppLayout,
  },
  data() {
    return {
      isLoggedIn: checkLoggedIn(),
    };
  },
  methods: {
    onLoginSuccess() {
      this.isLoggedIn = true;
    },
    onLogout() {
      removeToken();
      localStorage.removeItem("isLoggedIn");
      this.isLoggedIn = false;
    },
  },
};
</script>

<style>
html,
body {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

#app {
  width: 100%;
  height: 100%;
  font-family: "Microsoft YaHei", "PingFang SC", Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
